import { render } from "./WitnessSignatureComponent.vue?vue&type=template&id=0ac40867&ts=true"
import script from "./WitnessSignatureComponent.vue?vue&type=script&lang=ts"
export * from "./WitnessSignatureComponent.vue?vue&type=script&lang=ts"

import "./WitnessSignatureComponent.vue?vue&type=style&index=0&id=0ac40867&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__